<template>
  <div id="login">
    <canvas id="pixie"></canvas>
    <div login-div-conatainer>
      <!-- <img login-form-logo src="../assets/imgs/login/login_login.png" /> -->

      <div login-div-wrap>
        <div login-div-wrap-head>牛人搭档</div>
        <div login-div-right-table>
          <div login-div-right-table-cell>
            <div form-line>
              <div form-line-name>
                <div form-line-name-zh>用户名</div>
                <!-- <div form-line-name-en>Name</div> -->
              </div>
              <div form-line-input>
                <input v-model="loginRequest.UserName" autocomplete="new-password" placeholder="请输入您的用户名" @keyup.enter="login" >
                <span in-u-eyes @click="clearUserName">
                  <i class="el-icon-circle-close-outline"></i>
                </span>
              </div>
            </div>
            <div form-line>
              <div form-line-name>
                <div form-line-name-zh>密&nbsp;&nbsp;&nbsp;&nbsp;码</div>
                <!-- <div form-line-name-en>Password</div> -->
              </div>
              <div form-line-input>
                  <input :type="showPwd==false?'password':'text'" v-model="loginRequest.Password" @keyup.enter="login" 
                  placeholder="请输入您的密码">
                <!-- <input :type="showPwd==false?'password':'text'" v-model="loginRequest.Password" @keyup.enter="login" autocomplete="new-password"
                  placeholder="请输入您的密码"> -->
                <!-- <span in-u-eyes @click="setShowPwd" ><i class="el-icon-view"></i></span> -->
                <span in-u-eyes @click="setShowPwd">
                  <i :class="pwdIcon"></i>
                </span>
              </div>
            </div>
            <div form-line="btn">
                <el-button type="primary" :loading="loading" @click="login">登录</el-button>
              <!-- <button @click="login" v-loading="loading">登 录</button> -->
            </div>
            <!-- <div form-line="phone">客服电话：400-053-9994</div> -->
          </div>

        </div>
      </div>
    </div>
    <!-- <div copyright>
      <div> © AMOREPACIFIC CORPORATION. All rights reserved.
        <img src="../assets/imgs/login/icp.jpg"><a alink target="_blank" href="http://www.miitbeian.gov.cn">上海工商沪ICP备11011083号-8</a>
        <img src="../assets/imgs/login/police.png"> 沪公网安备 31010602001509 </div>
      <div>爱茉莉太平洋贸易有限公司</div>
      <div>地址：上海市石门一路288号兴业太古汇香港兴业中心一座7楼 电话：021-23290666</div>
    </div> -->
  </div>

</template>

<script>
  import { requestLogin } from "../api/api";
  import store from "../utils/storage";
  import NProgress from "nprogress";
  import "nprogress/nprogress.css";

  export default {
    name: "Login",
    data() {
      return {
        loginRequest: {
          UserName: '',
          Password: ''
        },
        showPwd: false,
        pwdIcon: 'fa fa-eye-slash',
        loading:false,
      };
    },
    mounted() {
      store.removeStore("jwt-token");
      store.removeStore("cur-user-info");
      store.removeStore("cur-user-menu");
      var curAcc = store.getStore('cur-user-account');
      if (curAcc) {
        this.loginRequest.UserName = curAcc;
      };
    },
    methods: {
      login() {
        NProgress.start();
        this.loading =true;
        requestLogin(this.loginRequest).then(res => {
          NProgress.done();
        this.loading =false;
          if (res.data.Code !== 1) return this.$message.error(res.data.Msg);

          store.setStore("jwt-token", res.headers["jwt-token"]);
          store.setStore("cur-user-info", JSON.stringify(res.data.Data));
          store.setStore("cur-user-account", this.loginRequest.UserName);

          var ms = store.getMenus();
          store.setStore("cur-user-menu", JSON.stringify(ms));
          this.$router.addRoutes(ms);
          this.$router.push({ path: "/home" });
        });
      },
      setShowPwd() {
        this.showPwd = !this.showPwd;
        if (this.showPwd)
          this.pwdIcon = 'el-icon-view';
        else
          this.pwdIcon = 'fa fa-eye-slash';
      },
      clearUserName() {
        this.loginRequest.UserName = '';
        store.removeStore("cur-user-account");
      }
    }
  };
</script>


<style scoped>
  @import "../assets/css/login.css";
</style>


// WEBPACK FOOTER //
// src/components/Login.vue